"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiresExpirationDate = requiresExpirationDate;
const qvet_inventory_1 = require("../constants/qvet-inventory");
/**
 * ¿Este artículo necesita fecha de caducidad, por su sección y su familia?
 *
 * No usa el árbol: le bastan las dos listas de caducidad. Por eso sobrevivió al borrado.
 *
 * ⚠️ `FAMILIES_REQUIRE_EXPIRATION` localiza las familias **por nombre dentro de una sección**.
 * Medido el 2026-09-08: eso **no es ambiguo** —hay 24 nombres de familia repetidos en el
 * catálogo, pero **ninguno dentro de la misma sección**—, así que la forma se sostiene.
 */
function requiresExpirationDate(section, family) {
    if (qvet_inventory_1.SECTIONS_REQUIRE_EXPIRATION.includes(section)) {
        return true;
    }
    const familiesForSection = qvet_inventory_1.FAMILIES_REQUIRE_EXPIRATION[section];
    return familiesForSection ? familiesForSection.includes(family) : false;
}
